import { Navigate, Route, Routes, useParams } from "react-router-dom";
import { AuthBootstrap } from "@/components/auth-bootstrap";
import { defaultLocale, isLocale } from "@/i18n";
import { I18nProvider } from "@/providers/I18nProvider";
import AuthorizePage from "@/pages/authorize/page";
import ForgotPasswordPage from "@/pages/forgot-password/page";
import LoginPage from "@/pages/login/page";
import VerificationPage from "@/pages/verification/page";
import ResetPasswordPage from "@/pages/reset-password/page";
import SignUpPage from "@/pages/sign-up/page";

function LocaleOrDefaultLogin() {
  return <Navigate to={`/${defaultLocale}/login`} replace />;
}

function LocaleIndexRedirect() {
  const { locale: localeParam } = useParams<{ locale: string }>();
  const locale = isLocale(localeParam) ? localeParam : defaultLocale;
  return <Navigate to={`/${locale}/login`} replace />;
}

/** Legacy `/onboarding` bookmarks → `/verification`. */
function LegacyOnboardingToVerificationRedirect() {
  const { locale: localeParam } = useParams<{ locale: string }>();
  const locale = isLocale(localeParam) ? localeParam : defaultLocale;
  return <Navigate to={`/${locale}/verification`} replace />;
}

export function App() {
  return (
    <AuthBootstrap>
      <Routes>
        <Route path="/" element={<LocaleOrDefaultLogin />} />

        <Route path="/:locale" element={<I18nProvider />}>
          <Route index element={<LocaleIndexRedirect />} />
          <Route path="login" element={<LoginPage />} />
          <Route path="sign-up" element={<SignUpPage />} />
          <Route path="forgot-password" element={<ForgotPasswordPage />} />
          <Route path="reset-password" element={<ResetPasswordPage />} />
          <Route path="authorize" element={<AuthorizePage />} />
          <Route path="verification" element={<VerificationPage />} />
          <Route
            path="onboarding"
            element={<LegacyOnboardingToVerificationRedirect />}
          />
          <Route path="*" element={<LocaleIndexRedirect />} />
        </Route>

        <Route path="*" element={<LocaleOrDefaultLogin />} />
      </Routes>
    </AuthBootstrap>
  );
}
